import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Typography,
  Divider,
} from "@mui/material";
import { ConsultationGuideData } from "../GuideDetailsDialog";

interface BeneficiaryDataSectionProps {
  formData: ConsultationGuideData;
  onFieldChange: (name: string, value: any) => void;
}

export const BeneficiaryDataSection = ({
  formData,
  onFieldChange,
}: BeneficiaryDataSectionProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  const handleSelectChange = (event: any) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Dados do beneficiário
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            label="Nome"
            name="nomeBeneficiario"
            value={formData.nomeBeneficiario}
            onChange={handleChange}
            size="small"
            helperText="Nome completo do beneficiário"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Atend. RN</InputLabel>
            <Select
              name="atendimentoRN"
              value={formData.atendimentoRN}
              label="Atend. RN"
              onChange={handleSelectChange}
            >
              <MenuItem value="S">Sim</MenuItem>
              <MenuItem value="N">Não</MenuItem>
            </Select>
            <FormHelperText>Atendimento a recém-nascido</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            required
            fullWidth
            label="N° da carteira"
            name="numeroCarteira"
            value={formData.numeroCarteira}
            onChange={handleChange}
            size="small"
            helperText="Número da carteira do beneficiário"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Identificador do beneficiário"
            name="identificadorBeneficiario"
            value={formData.identificadorBeneficiario}
            onChange={handleChange}
            size="small"
            multiline
            rows={2}
            helperText="Código identificador do beneficiário na operadora"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
